// extracted by mini-css-extract-plugin
module.exports = {"text":"NewsletterSignupSection_text__A4q84","textWrap":"NewsletterSignupSection_textWrap__D1SPh","subText":"NewsletterSignupSection_subText__gG4L3"};